// Terminology override system — makes UI labels industry-specific
// Fallback chain: tenant override (org_settings.terminology) → template default → hardcoded default
import { useMemo } from 'react'
import { useBranding } from './branding'

const DEFAULTS = {
  site: 'Site',
  site_plural: 'Sites',
  crew_member: 'Crew Member',
  crew_member_plural: 'Crew Members',
  crew: 'Crew',
  shift: 'Shift',
  shift_plural: 'Shifts',
  client: 'Client',
  client_plural: 'Clients',
  contract: 'Contract',
  contract_plural: 'Contracts',
  clock_in: 'Clock In',
  clock_out: 'Clock Out',
  end_shift: 'End Shift',
  booking: 'Booking Request',
  invoice: 'Invoice',
  invoice_plural: 'Invoices',
  quote: 'Quote',
  quote_plural: 'Quotes',
  compliance_doc: 'Compliance Document',
  compliance_doc_plural: 'Compliance Documents',
  form: 'Form',
  form_plural: 'Forms',
  checklist: 'Checklist',
  checklist_plural: 'Checklists',
  schedule: 'Schedule',
  dashboard: 'Dashboard',
  field_work: 'Field Work',
}

export { DEFAULTS as TERMINOLOGY_DEFAULTS }

/**
 * @typedef {Record<string, string>} TerminologyMap
 */

/**
 * @returns {TerminologyMap}
 */
export function useTerminology() {
  const branding = useBranding()
  return useMemo(() => ({
    ...DEFAULTS,
    ...(branding?.terminology || {}),
  }), [branding?.terminology])
}
